<template>
	<SectionCard title="Clienti per nazione" icon="mdi-earth" subtitle="nazione di spedizione" no-padding data-tour="countries">
		<v-data-table
			:headers="headers"
			:items="rows"
			:items-per-page="25"
			:footer-props="{ 'items-per-page-options': [25, 50, 100] }"
			sort-by="spend"
			sort-desc
			dense
			item-key="country"
			class="elevation-0"
		>
			<template v-slot:[`item.country`]="{ item }">
				<div class="d-flex align-center" style="gap: 8px">
					<img v-if="flag(item.country)" :src="flag(item.country)" alt="" class="cc-flag" />
					<span>{{ nomePaese(item.country, item.country) }}</span>
				</div>
			</template>
			<template v-slot:[`item.customers`]="{ item }">{{ formatNumber(item.customers) }}</template>
			<template v-slot:[`item.orders`]="{ item }">{{ formatNumber(item.orders) }}</template>
			<template v-slot:[`item.spend`]="{ item }">{{ formatEurCents(item.spend) }}</template>
			<template v-slot:[`item.spendPerCustomer`]="{ item }">{{ formatEurCents(item.spendPerCustomer) }}</template>
			<template v-slot:[`item.newShare`]="{ item }">{{ formatPct(item.newShare) }}</template>
		</v-data-table>
		<div v-if="multiMonth" class="cc-note pa-3">Su più mesi un cliente che compra in mesi diversi conta una volta per mese.</div>
	</SectionCard>
</template>

<script>
import SectionCard from '@/components/core/SectionCard.vue';
import { formatEurCents, formatNumber, formatPct } from '../format';
import { nomePaese, bandiera } from '@/components/stats/format';

export default {
	name: 'CustomersCountries',
	components: { SectionCard },
	props: {
		rows: { type: Array, default: () => [] },
		multiMonth: { type: Boolean, default: false },
	},
	data() {
		return {
			headers: [
				{ text: 'Nazione', value: 'country' },
				{ text: 'Clienti', value: 'customers', align: 'end' },
				{ text: 'Ordini', value: 'orders', align: 'end' },
				{ text: 'Spesa', value: 'spend', align: 'end' },
				{ text: 'Spesa per cliente', value: 'spendPerCustomer', align: 'end' },
				{ text: 'Quota nuovi', value: 'newShare', align: 'end' },
			],
		};
	},
	methods: {
		formatEurCents,
		formatNumber,
		formatPct,
		nomePaese(code, fallback) {
			return code === 'N/D' ? 'Non indicata' : nomePaese(code, fallback);
		},
		flag(code) {
			return code && code !== 'N/D' ? bandiera(code) : null;
		},
	},
};
</script>

<style scoped>
.cc-flag {
	width: 20px;
	height: 14px;
	object-fit: cover;
	border-radius: 2px;
}
.cc-note {
	font-size: 12px;
	color: #5f6b7a;
}
</style>
